import React, { useState, createContext, useContext } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from './Sections/Header';

import Home from './Pages/Home';
import Contact from './Pages/Contact.tsx';
import About from './Pages/About/About.tsx';
import Apartment from './Pages/Apartment/Apartment.jsx';
import Apartments from './Sections/Apartments.jsx';
import Footer from "./Sections/Footer.jsx"

import sr from './Translations/sr';
import en from './Translations/en';
import de from './Translations/de';
export const LanguageContext = createContext(null);
const App = () => {
    const [language, setLanguage] = useState('sr')
    const changeLanguage = (lang) => setLanguage(lang);

    const translations = { sr, en, de };
    const t = translations[language];

    return (
        <LanguageContext.Provider value ={{language, t}}>

            <Header t={t} changeLanguage= {changeLanguage} language = {language} />
            <Routes>
                <Route path="/" element={<Home t={t} language={language}/>} />
                <Route path="/contact" element={<Contact t={t} />} />
                <Route path="/about" element={<About t={t} />} />
                <Route path="/apartment/:name" element={<Apartment  />} />
                <Route path="/apartments" element={<Apartments  t={t} language={language} />} />
            </Routes>
            <Footer t={t} />
        </LanguageContext.Provider>
    );
};

export default App;
